module.exports = __webpack_public_path__ + "static/media/Ellipse6.d75d5bad.png";